export const DATE_TIME_REGEX = {
  date: new RegExp("^((?:19|20)\\d\\d)[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$"),
};
export const DATE_FORMAT = "DD.MM.YYYY";
